import {
  FETCH_PLATFORMS_START,
  FETCH_PLATFORMS_SUCCESS,
  FETCH_PLATFORMS_ERROR,
  CREATE_PLATFORM_START,
  DELETE_PLATFORM_START,
  DELETE_PLATFORM_SUCCESS,
  DELETE_PLATFORM_ERROR,
  UPDATE_PLATFORM_START,
} from "./platforms.types"

const INITIAL_STATE = {
  list: null,
  isFetching: false,
  errorMessage: "",
  options: [],
  sums: [],
}

const platformsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PLATFORMS_START:
      return {
        ...state,
        isFetching: true,
      }
    case FETCH_PLATFORMS_SUCCESS:
      return {
        ...state,
        list: action.payload,
        isFetching: false,
        errorMessage: "",
      }
    case FETCH_PLATFORMS_ERROR:
      return {
        ...state,
        list: null,
        errorMessage: action.payload,
      }
    case CREATE_PLATFORM_START:
      return {
        ...state,
        isFetching: true,
      }
    case UPDATE_PLATFORM_START:
      return {
        ...state,
        isFetching: true,
      }
    case DELETE_PLATFORM_START:
      return {
        ...state,
        isFetching: true,
      }
    case DELETE_PLATFORM_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: "",
      }
    case DELETE_PLATFORM_ERROR:
      return {
        ...state,
        errorMessage: action.payload,
      }
    default:
      return state
  }
}

export default platformsReducer
